import React from "react";
import MetaTags from "react-meta-tags";
import Subscribe from "../../component/Subscribe";
import "../../common/SCSS/newsletterStyle.css";
function Newsletter_49() {
  return (
    <>
      <section
        className="about-banner-section"
        style={{ padding: "150px 0 62px" }}
      >
        <div className="about-circle">
          <div className="about-circle-1"></div>
          <div className="about-circle-2"></div>
          <div className="about-circle-3"></div>
          <div className="about-circle-4"></div>
          <div className="about-circle-5"></div>
        </div>
        <div className="about-banner-container">
          <div className="about-content">
            <h1 className="about-title" style={{ paddingTop: "25px" }}>
              SustainabilityConnect
            </h1>
            <p
              className="about-description"
              style={{ fontSize: "25px", marginTop: "18px", marginBottom: "0" }}
            >
              Newsletter October 2026
            </p>
          </div>
        </div>
        <div className="about-elements">
          <div className="about-element-1"></div>
          <div className="about-element-2"></div>
          <div className="about-element-3"></div>
          <div className="about-element-4"></div>
          <div className="about-element-5"></div>
        </div>
      </section>
      <div className="newsletter-container">
        <MetaTags>
          <title>
            ISO and UNDP Introduce Global Framework for SDG Management.
          </title>
          <meta
            name="description"
            content="ISO/UNDP 53001 establishes the first international, requirements-based management system standard dedicated to the United Nations Sustainable Development Goals."
          />
          <meta
            property="og:title"
            content="UpdaptCSR | Sustainability Platform"
          />
        </MetaTags>

        <div
          className="Newsletter-title1"
          style={{ paddingTop: "56px", fontSize: "32px" }}
        >
          ISO and UNDP Introduce Global Framework for SDG Management.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/October_2026_1.webp")}
            alt="ISO and UNDP Introduce Global Framework for SDG Management."
            loading="lazy"
          />
        </figure>
        <p>
          ISO/UNDP 53001 establishes the first international, requirements-based
          management system standard dedicated to the United Nations Sustainable
          Development Goals. Developed jointly by ISO and UNDP, it enables
          organizations of every size, sector and geography to embed sustainable
          development priorities within governance, strategy, operations and
          decision-making.
        </p>
        <p>
          The standard uses the Plan-Do-Check-Act approach, helping
          organizations identify beneficial and adverse impacts, engage relevant
          stakeholders, set meaningful objectives, collect data and evaluate
          performance. It covers all 17 SDGs while recognizing their
          interdependencies, synergies and trade-offs. Its structure also
          supports integration with established systems such as ISO 9001 for
          quality management and ISO 14001 for environmental management.
        </p>
        <p>
          ISO/UNDP 53001 is intended for businesses, public bodies, educational
          institutions and civil society organizations. It provides a common
          framework through which governments, investors and development
          institutions can assess how sustainability commitments are implemented
          and measured. Designed to remain applicable beyond the 2030 Agenda,
          the standard will undergo ISO’s regular review process, with
          sector-specific implementation guidance expected to support adoption
          across different industries and markets.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            ISO/UNDP 53001 can help businesses move from broad sustainability
            commitments to disciplined execution. By connecting SDG priorities
            with governance, risk management, operational controls and
            performance measurement, it creates clearer accountability across
            functions. Its compatibility with established ISO systems can reduce
            duplication and support consistent implementation. For investors,
            customers and regulators, structured evidence of progress can
            strengthen confidence, while helping management identify material
            impacts, emerging opportunities and areas requiring corrective
            action.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Canada Updates National Climate Evidence for Resilience Planning
        </div>
        <div className="Newsletter-picture">
          <figure style={{ marginTop: "25px" }}>
            <img
              className="picture"
              src={require("../../../../../assets/Newsletter/October_2026_2.webp")}
              alt="Canada Updates National Climate Evidence for Resilience Planning"
              loading="lazy"
            />
          </figure>
        </div>
        <p>
          Canada’s Changing Climate Report 2026 provides a scientific foundation
          for national resilience planning, building on the first assessment
          issued in 2019. Drawing on peer-reviewed research and contributions
          from more than 100 Canadian experts, the ten-chapter report examines
          observed and projected changes in temperature, precipitation, oceans,
          freshwater, ice, permafrost, wildfires and climate extremes.
        </p>
        <p>
          The assessment finds that Canada warmed by 2.0°C between 1948 and
          2023, while northern Canada warmed by 2.6°C. Since 1970, national
          warming has occurred at nearly twice the global average rate, with the
          Arctic warming three times as quickly. Average temperatures are
          projected to rise by approximately 0.9°C between 2021 and 2040 across
          all emissions scenarios.
        </p>
        <p>
          The report supports Canada’s National Adaptation Strategy by supplying
          climate information for policy development, infrastructure planning,
          emergency preparedness and investment decisions. It also incorporates
          case studies from First Nations, Inuit and Métis communities,
          broadening the evidence available to decision-makers. Its findings can
          help governments, businesses and communities assess physical climate
          risks, improve adaptation planning and direct resources towards
          resilient assets and services.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            For Canada, where warming is occurring at nearly twice the global
            average pace, reliable climate evidence is essential for public
            planning. The assessment gives governments, businesses and
            communities a common basis for evaluating heat, wildfire, flooding,
            water and infrastructure risks. It can guide adaptation spending,
            emergency preparation and long-term investment toward assets and
            services suited to changing conditions.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          Australia Introduces Centralised Climate Reporting for Government
          Entities.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/October_2026_3.webp")}
            alt="Australia Introduces Centralised Climate Reporting for Government Entities."
            loading="lazy"
          />
        </figure>
        <p>
          Australia is moving Commonwealth climate reporting onto a central
          public platform. From the 2025–26 reporting year, participating
          government entities and companies must publish climate disclosures and
          greenhouse gas inventories through the Transparency Portal using the
          Digital Annual Reporting Tool. Annual reports will reference the
          standalone disclosure, making information easier for Parliament and
          the public to locate.
        </p>
        <p>
          The Commonwealth Climate Disclosure framework follows four areas:
          governance, strategy, risk management, and metrics and targets. Its
          requirements draw on the Australian Sustainability Reporting Standard
          AASB S2, adapted for the public sector. Reporting is being introduced
          in tranches, with requirements increasing as entities develop their
          processes, data systems and understanding of climate-related risks and
          opportunities.
        </p>
        <p>
          Tranche 1 entered the framework in 2024–25, while Tranche 2 begins
          reporting for 2025–26. Tranche 3 will follow in 2026–27 under
          simplified requirements. Emissions datasets and climate reports will
          be stored centrally, supporting comparison between entities and access
          over time. The accompanying emissions framework sets common methods
          for measuring greenhouse gases, including mandatory location-based
          inventories and electricity emissions tables.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            Commonwealth entities will need to treat climate disclosure as an
            extension of financial governance rather than a separate
            sustainability exercise. Preparation should centre on reconciling
            emissions boundaries with controlled-entity structures, assigning
            owners across the four disclosure pillars, documenting estimation
            methods, and linking climate assumptions to financial statements.
            Early DART testing and evidence trails will reduce reporting
            friction and review queries.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          FCA Sets New ISSB-Based Sustainability Disclosure Rules for UK-Listed
          Companies.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/October_2026_4.webp")}
            alt="FCA Sets New ISSB-Based Sustainability Disclosure Rules for UK-Listed Companies."
            loading="lazy"
          />
        </figure>
        <p>
          The Financial Conduct Authority has finalised sustainability
          disclosure rules for UK-listed companies, replacing the TCFD-based
          regime with reporting against UK Sustainability Reporting Standards.
          Based on the International Sustainability Standards Board framework,
          UK SRS S1 covers sustainability-related financial information, while
          UK SRS S2 addresses climate-related risks and opportunities. Both will
          operate on a comply-or-explain basis.
        </p>
        <p>
          The rules apply to accounting periods beginning on or after 1 January
          2027, with the first reports expected in 2028. In-scope issuers
          include commercial companies, secondary listings, depositary receipts
          and certain non-voting or non-equity share categories. Disclosures
          must accompany the related financial reporting, linking sustainability
          information more closely with investor analysis and capital
          allocation.
        </p>
        <p>
          Companies may use a one-year transitional relief for Scope 3 emissions
          and a two-year relief for wider sustainability disclosures under UK
          SRS S1. The shift follows the UK’s adoption of TCFD-aligned listing
          rules between 2020 and 2021 and the ISSB’s publication of IFRS S1 and
          S2 in 2023. Further technical guidance is being developed to clarify
          proportionate application of the comply-or-explain model.
        </p>

        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            UK-listed issuers should map UK SRS data ownership across finance,
            risk, legal and sustainability teams before the 2027 reporting
            period. Preparation requires testing materiality decisions,
            documenting comply-or-explain judgements, reconciling Scope 3
            boundaries with financial consolidation, and aligning reporting
            timetables. Audit-ready evidence, controlled estimation methods and
            formal board-approved governance records will be essential when
            sustainability disclosures directly accompany annual financial
            reports.
          </p>
        </div>
        <div className="Newsletter-title" style={{ paddingTop: " 57px" }}>
          India Brings Net-Zero Commitments and Climate Missions onto National
          Digital Platforms.
        </div>
        <figure style={{ marginTop: "25px" }}>
          <img
            className="picture"
            src={require("../../../../../assets/Newsletter/October_2026_5.webp")}
            alt="India Brings Net-Zero Commitments and Climate Missions onto National Digital Platforms."
            loading="lazy"
          />
        </figure>

        <p>
          India has introduced a Net Zero Portal and a National Action Plan on
          Climate Change dashboard to organise climate commitments and track
          policy delivery. They support India’s 2070 net-zero target and its
          commitment to reduce GDP emissions intensity by 45% from 2005 levels
          by 2030.
        </p>
        <p>
          The Net Zero Portal allows entities to register voluntary targets,
          disclose greenhouse gas emissions and report progress. Participants
          are encouraged to provide Scope 1 and Scope 2 data, while Scope 3
          reporting remains voluntary. Entities may also describe transition
          pathways covering clean energy, efficiency measures, technology
          changes and carbon removals. Submitted declarations are publicly
          accessible and acknowledged by the environment ministry.
        </p>
        <p>
          The NAPCC dashboard brings information and indicators from nine
          national climate missions into one digital system, covering areas
          including solar energy, water, energy efficiency, sustainable
          habitats, agriculture and health. It also presents state-level climate
          action information across India’s 28 states and eight union
          territories. Ministries can use the platform to monitor sectoral
          performance, identify implementation gaps and connect domestic
          programmes with international climate commitments.
        </p>
        <div className="updapt-views">
          <div className="views" style={{ display: "flex" }}>
            <img
              src={require("../../../../../assets/Newsletter/view1.svg")}
              width="40px"
              height="40px"
              alt="view1"
            />
            <h3>Updapt Views:</h3>
          </div>
          <p style={{ marginLeft: " 22px", color: "white", width: "96%" }}>
            For India, the portals create a national data layer connecting
            voluntary targets, emissions and implementation progress. This
            visibility will inform credit assessment, procurement decisions,
            sector policy and climate-finance allocation. Businesses will face
            closer examination of baseline years, emissions boundaries and
            delivery pathways, while well-documented disclosures will support
            access to transition finance, supply-chain partnerships and India’s
            developing carbon market over time.
          </p>
        </div>
      </div>
      <Subscribe />
    </>
  );
}

export default Newsletter_49;
